module["exports"] = [
  "#{street_prefix} #{Name.last_name}"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/pl/address/street_name.js
// module id = 1936
// module chunks = 0